import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencil3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pencil-3, edit, write, prompt"><path d="M15.0294 3.82353L4.27941 14.5735L3.25 20.75L9.42647 19.7206L20.1765 8.97059C21.5978 7.54927 21.5978 5.24485 20.1765 3.82353C18.7552 2.40221 16.4507 2.40221 15.0294 3.82353Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M17.5 6.5L14.5 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPencil3;
